/*
 *
 * Copyright 2019, White River Computing LLC. All rights reserved.
 * For licensing information, please contact Charlie Flock (cflock@whiterivercomputing.com or 888-802-6340)
 */

import React from "react";
import ReactDOM from "react-dom";
import PropTypes from "prop-types";
import {Button} from "@blueprintjs/core";
import {Intent} from "@blueprintjs/core/lib/esm/index";
import {WrcEmail} from "./WrcEmail.js";

export class WrcEmailOpener extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            canOutsideClickClose: false,
            is_loaded: false,
        };
    }

    openEmail() {
        ReactDOM.render(
            <WrcEmail
                    refresh={this.props.refresh}
                    component_index={this.props.component_index}
                    configure_component={this.props.configure_component}
                    table_schema={this.props.table_schema}
                    table_name={this.props.table_name}
                    recipients={this.props.recipients}
                    date_component={this.props.date_component}
                    content_query={this.props.content_query}
                    template={this.props.template}
                    non_ideal_state_message={this.props.non_ideal_state_message}
                    default_subject={this.props.default_subject}
                    user={this.props.user}
                    specified_recipient_name={this.props.specified_recipient_name}
                    specified_recipient_email={this.props.specified_recipient_email}
                    recipient_type={this.props.recipient_type}
                    title={this.props.title}
                    record={this.props.record}
                 />,
            document.querySelector('#email'));
    }

    componentDidMount() {
        this.setState({
            is_loaded: true
        });
    }

    render() {
        if (this.state.is_loaded) {
            return (
                <div className="wd-record">
                    <Button icon='envelope'
                            intent={Intent.PRIMARY}
                            text={this.props.button_text}
                            style={{marginTop: '1em'}}
                            fill={false}
                            onClick={() => this.openEmail()} />
                </div>
            );
        }
        else {
            return (<div>Loading...</div>);
        }
    }
}


WrcEmailOpener.propTypes = {
    button_text: PropTypes.string.isRequired,
    refresh: PropTypes.func,
    component_index: PropTypes.number,
    configure_component: PropTypes.func,
};
